import {
  AiAgentToolParameterDto,
  AiAgentToolParameterType,
  PreparationState,
} from './ai-agents.model';

export const AGENTIC_AI_FEATURE = 'AgenticAi.EnableAgenticAiFeature';
export const CUSTOM_MODEL = 'custom model';
export const AVATAR_BASE_PATH = 'assets/images/agent-avatars';
export const DEFAULT_AGENT_AVATAR = `${AVATAR_BASE_PATH}/default-agent-avatar.jpg`;

export const DISABLING_COLLABORATION_WITH_SUB_AGENTS_ERROR_CODE = 'Raven:0100193';
export const ENABLING_COLLABORATION_FOR_SUB_AGENT_ERROR_CODE = 'Raven:0100204';
export const DISABLING_STRICT_TOOL_MODE_WHILE_OPTIONAL_PARAMETERS_EXIST = 'Raven:0100237';

export const AI_AGENT_FIELD_CONSTS = {
  nameMaxLength: 200,
  descriptionMaxLength: 200,
  instructionsMaxLength: 100000,
  avatarImageMaxSizeInBytes: 1024 * 100, // 100 KB
  llmModelMaxLength: 200,
  tokenPerMinuteDefaultValue: 30000,
  tokenPerMinuteMinValue: 10000,
  tokenPerMinuteMaxValue: 50000000,
  archiveDescriptionMaxLength: 200,
  maxArchiveCount: 20,
};

export const AI_AGENT_COMPARE_CONSTS = {
  currentVersionValue: 'current',
  diffEditorLanguage: 'plaintext',
  compareSideLeft: 'left',
  compareSideRight: 'right',
};

export const AI_AGENT_SUB_AGENT_FIELD_CONSTS = {
  collaborationInstructionsMaxLength: 900,
};

export const AI_AGENT_TOOL_FIELD_CONSTS = {
  nameMaxLength: 64,
  descriptionMaxLength: 900,
};

export const AI_AGENT_TOOL_PARAMETER_CONSTS = {
  nameMaxLength: 200,
  descriptionMaxLength: 900,
  maxNumberOfEnumValues: 100,
};

export const AI_AGENT_FORM_NAMES = {
  generalSettings: 'generalSettings',
  interactionSettings: 'interactionSettings',
  guardrailsSettings: 'guardrailsSettings',
  llmSettings: 'llmSettings',
};

export const AI_AGENT_TOOL_FORM_NAMES = {
  httpRequestToolParameters: 'httpRequestToolParameters',
};

export const AI_AGENT_FIELD_NAMES = {
  avatar: 'avatar',
  name: 'name',
  description: 'description',
  collaborationMode: 'collaborationMode',
  avoidHarmfulOrUnethicalContent: 'avoidHarmfulOrUnethicalContent',
  stayGroundedToVerifiedInformation: 'stayGroundedToVerifiedInformation',
  detectAndBlockJailbreakAttempts: 'detectAndBlockJailbreakAttempts',
  maintainOutputConsistency: 'maintainOutputConsistency',
  persona: 'persona',
  creativityLevel: 'creativityLevel',
  responseDetailLevel: 'responseDetailLevel',
  instructions: 'instructions',
  llmConfiguration: 'llmConfiguration',
  llmModel: 'llmModel',
  llmCustomModel: 'llmCustomModel',
  guardrailId: 'guardrailId',
  reasoningEffort: 'reasoningEffort',
  tokenPerMinute: 'tokenPerMinute',
};

export const AI_AGENT_FORM_DATA_KEYS = {
  avatarImage: 'avatarImage',
  name: 'name',
  description: 'description',
  collaborationMode: 'collaborationMode',
  avoidHarmfulOrUnethicalContent: 'avoidHarmfulOrUnethicalContent',
  stayGroundedToVerifiedInformation: 'stayGroundedToVerifiedInformation',
  detectAndBlockJailbreakAttempts: 'detectAndBlockJailbreakAttempts',
  maintainOutputConsistency: 'maintainOutputConsistency',
  isAvatarImageChanged: 'isAvatarImageChanged',
  persona: 'persona',
  creativityLevel: 'creativityLevel',
  responseDetailLevel: 'responseDetailLevel',
  instructions: 'instructions',
  llmConfigurationId: 'llmConfigurationId',
  isCustomLlmModelSelected: 'isCustomLlmModelSelected',
  llmModel: 'llmModel',
  projectId: 'projectId',
  projectVersionId: 'projectVersionId',
  guardrailId: 'guardrailId',
  reasoningEffort: 'reasoningEffort',
};

export const getFormattedParameterName = (parameter: AiAgentToolParameterDto): string => {
  return parameter.name || '[' + getTypeName(parameter.type) + ']';
};

export const getPreparationStateColor = (preparationState: PreparationState): string => {
  switch (preparationState) {
    case PreparationState.preparationFailed:
      return '#ee6f42';
    case PreparationState.prepared:
      return 'var(--bs-teal)';
    default:
      return 'var(--bs-gray-500)';
  }
};

const getTypeName = (type: AiAgentToolParameterType): string => {
  return AiAgentToolParameterType[type] ?? 'unknown';
};
